/**
 * v6: `Redirect` was removed; `Navigate` is the direct replacement for the
 * declarative "render this and it redirects" use case used here (as opposed
 * to imperative redirects, which use the `useNavigate()` hook instead).
 *
 * Redirects only when the active session matches the page type. A business
 * session on the customer login page (or a customer session on the business
 * login page) renders the page so the user can switch accounts; logging in
 * replaces the existing session. Firebase ID tokens carry a `firebase` claim
 * and backend JWTs don't, which is how the session type is told apart.
 */
import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

export const AuthorizedRedirect = ({
  authorized,
  isCustomerSession,
  signUpFlowActive = false,
  isCustomer = false,
}) => {
  if (!authorized || signUpFlowActive) {
    return null;
  }

  if (isCustomer !== isCustomerSession) {
    return null;
  }

  return <Navigate to={isCustomer ? '/Home' : '/dashboard'} replace />;
};

AuthorizedRedirect.propTypes = {
  authorized: PropTypes.bool,
  isCustomerSession: PropTypes.bool,
  signUpFlowActive: PropTypes.bool,
  isCustomer: PropTypes.bool,
};

const mapStateToProps = state => ({
  authorized: state.auth.authorized,
  isCustomerSession: Boolean(
    state.auth.tokens.accessDecoded && state.auth.tokens.accessDecoded.firebase,
  ),
});

export default connect(mapStateToProps)(AuthorizedRedirect);